const styles = theme => ({
  root: {
    marginTop: 24,
    alignItems: 'center',
    textAlign: 'center',
  },
  button: {
    position: 'relative',
    width: '50%',
    maxWidth: 240,
    height: 'auto',
    padding: 12,
    margin: 12,
    [theme.breakpoints.up('sm')]: {
      padding: 20,
      margin: 20,
    },
    [theme.breakpoints.up('md')]: {
      padding: 20,
      margin: 20,
    },
  },
  text: {
    paddingTop: 12,
    marginBottom: 24,
    marginLeft: 12,
    marginRight: 24,
    fontSize: 15,
    [theme.breakpoints.up('sm')]: {
      fontSize: 18,
      paddingTop: 40,
      marginBottom: 40,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
      paddingTop: 40,
      marginBottom: 40,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Support/scenes/Start/styles.js